module.exports = __webpack_public_path__ + "media/images/icons/instagramIcon-115799e0ec69ecfd5c7165bb5a51b375.svg";